import { useEffect, useState } from 'react';
import { db } from '../firebase';
import { firebaseCollections as collections } from '../constants';
import { getNow } from 'utils/helpers';

import { parseOrders } from 'utils/api/orders';

/**
 * Listens for changes in the parse Document in
 * the ordersMetaData collection to check
 * whether orders Parsing is on going or done.
 */
export default function useRefresh() {
  let [parsing, setParsing] = useState(false);
  const [lastRefresh, setLastRefresh] = useState(null);
  const [refreshDisabled, setRefreshDisabled] = useState(false);
  const [waiting, setWaiting] = useState(false);

  /**
   * handle refresh when button is clicked
   * */
  const handleRefresh = () => {
    if (!waiting) {
      parseOrders();
    }
  };

  /**
   * Parse Orders when the refresh button is clicked
   * */
  useEffect(() => {
    setRefreshDisabled(parsing);
    let doneParsing = !parsing && waiting;
    if (parsing) {
      setWaiting(true);
    }
    if (doneParsing) {
      setWaiting(false);
    }
  }, [parsing]);

  useEffect(() => {
    const unsubscribe = db
      .collection(collections.ordersMetaData)
      .doc('parse')
      .onSnapshot(function (doc) {
        const { lastOrderParsing, isParsing } = doc.data();
        setLastRefresh(lastOrderParsing ?? getNow());
        setParsing(isParsing ?? false);
      });
    return () => {
      unsubscribe();
    };
  }, []);

  return {
    parsing,
    lastRefresh,
    trigger: handleRefresh,
    disabled: refreshDisabled,
  };
}
